<template>
  <jade-modal
    open
    :title="$t('title', { acquirer: $t(acquirer.payment_method) })"
    @onClose="$emit('close')"
  >
    <div class="flex flex-col gap-3">
      <jade-text
        variant="regular"
        color="medium"
      >
        {{ $t('description', { acquirer: $t(acquirer.payment_method) }) }}
      </jade-text>
    </div>

    <template #actions>
      <jade-button-group>
        <jade-button
          variant="primary-solid"
          :loading="loading"
          @click="$emit('confirm')"
        >
          {{ $t('general.continue') }}
        </jade-button>

        <jade-button
          variant="neutral-subtle"
          @click="$emit('close')"
        >
          {{ $t('general.cancel') }}
        </jade-button>
      </jade-button-group>
    </template>
  </jade-modal>
</template>

<script>
import { JadeButton, JadeButtonGroup, JadeModal, JadeText } from '@jade'

export default {
  name: 'CreateAcquirerAffiliationModal',
  components: {
    JadeText,
    JadeModal,
    JadeButton,
    JadeButtonGroup
  },
  props: {
    acquirer: {
      type: Object,
      required: true
    },
    loading: Boolean
  }
}
</script>

<i18n src="../affiliations.translation.json" />

<i18n>
  {
    "pt-BR": {
      "description": "Para realizar a sua afiliação será necessário realizar a autenticação na interface da {acquirer}. Após esse processo, você será redirecionado de volta para a nossa Dashboard.",
      "title": "Cadastrar afiliação {acquirer}"
    },
    "en-US": {
      "description": "For your affiliation you need to authenticate on the {acquirer} interface. After the process is done you will be redirected to our Dashboard.",
      "title": "Create an affiliation on {acquirer}"
    }
  }
</i18n>
